module.exports = __webpack_public_path__ + "static/img/consult-image.db3eb7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/consult-image.png
// module id = rFx3
// module chunks = 2